import React, { useContext } from "react";
import { Label } from "structure/Document";
import { ContextCreateEgress } from "../Add";
import InformativeTooltip from "components/individual/InfoTooltip";

export default function Beneficiary() {
  const hook = useContext(ContextCreateEgress);

  return (
    <div>
      <Label>
        Beneficiario{" "}
        {typeof hook.provider === "number" ? (
          <InformativeTooltip>
            <p>
              Para escribir un beneficiario debes de borrar el campo
              <b>Proveedor</b>
            </p>
          </InformativeTooltip>
        ) : null}
      </Label>
      {typeof hook.provider === "number" ? (
        <p>{hook.providerSocialReason}</p>
      ) : (
        <input
          type="text"
          disabled={typeof hook.provider === "number"}
          maxLength={256}
          value={hook.beneficiary}
          placeholder="Escribe aquí (Opcional)"
          onChange={(e) => hook.setBeneficiary(e.target.value)}
        />
      )}
    </div>
  );
}
